import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'sortByOrder',
  pure: false
})
export class SortByOrderPipe implements PipeTransform {

  transform(value: any[]): any[] {
    return value.sort((n1,n2) => 
    {
      return n1.order - n2.order; 
    });
  }
}


// WEBPACK FOOTER //
// /src/pages/apps/lineup/directives/sort-by-order/sort-by-order.ts